import React, { Component } from "react";
import PropTypes from "prop-types";
import { grey } from "material-ui/colors/index";
import { Button, Typography } from "material-ui";
import { ErrorOutline } from "material-ui-icons";
import { withStylesAndTranslation } from "../utils/container";

const styleSheet = theme => ({
    error: {
        textAlign: "center"
    },
    errorOutline: {
        height: 200,
        width: 200,
        fill: grey[500]
    },
    button: {
        margin: theme.spacing.unit * 2
    }
});

class LoadingError extends Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        onRetry: PropTypes.func.isRequired,
        retryText: PropTypes.string,
        message: PropTypes.string.isRequired,
        t: PropTypes.func.isRequired
    };

    static defaultProps = {
        retryText: ""
    };

    render() {
        let { t, classes, onRetry, message, retryText } = this.props;
        if (!retryText) {
            retryText = t("Try again");
        }
        return (
            <div className={classes.error}>
                <ErrorOutline className={classes.errorOutline} />
                <Typography type="body1">
                    {message}
                </Typography>
                <Button
                    className={classes.button}
                    raised
                    color="accent"
                    onClick={onRetry}>
                    {retryText}
                </Button>
            </div>
        );
    }
}

export default withStylesAndTranslation(LoadingError, styleSheet);



// WEBPACK FOOTER //
// ./src/components/LoadingError.jsx